import { ThrowStmt } from '@angular/compiler';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-custom-drop-down-renderer',
  template: `
    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownList" (onSelect)="onSelect($event, 0)" (onSelectAll)="onSelect($event, 0)" (onDeSelect)="onSelect($event, 1)" (onDeSelectAll)="onSelect($event, 1)">
    </ng-multiselect-dropdown>
    `
})

export class CellDropDownRendererComponent implements ICellRendererAngularComp {

    params;
    label: string;
    dropdownSettings;
    dropdownList;

    agInit(params): void {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'ID',
            textField: 'Name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: false
        };
        this.params = params;
        this.dropdownList = params.dropdownList;
    }

    refresh(params?: any): boolean {
        return true;
    }

    onSelect ($event, IsDeSelect) {
        if (this.params.onClick instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                IsDeSelect: IsDeSelect
            }
            this.params.onClick(params);
        }
    }
}